
<nav class="conditions navbar navbar-expand-lg navbar-light fixed-top shadow-sm" id="mainNav">
  <div class="container-fluid pl-5 pr-5">

  
  <!-- <div class="container-fluid px-5"  > -->
  <a class="navbar-brand fw-bold" href="#page-top">
    <img src="./assets/img/doktorslogo.png" id="logo" style="width:150px; " /></a>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" #clos data-bs-target="#navbarResponsive"
    (blur)="closemenu()" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
    Menu
    <i class="bi-list"></i>
  </button>
  <!-- <button type="button" class="close" (click)="closebtne()">&times;</button> -->
  <div class=" collapse navbar-collapse" id="navbarResponsive">
    <ul class="navbar-nav ms-auto  my-lg-0" style="margin-right:15px;">
      <li class="nav-item">
        <a class="nav-link me-lg-3" href="#features">Services</a>
      </li>
      <!-- <li class="nav-item">
                <a class="nav-link me-lg-3" href="#features">Services</a>
              </li> -->
      <li class="nav-item">
        <a class="nav-link me-lg-3" href="contact">Contact</a>
      </li>
      <!-- <li class="nav-item dropdown">

        <div class="input-group mr-1" id="navbarDropdown" role="butt" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <p id="cityinput" style="text-transform: capitalize;max-width: 135px; border-right: 0;" (click)="openNav()"
            autocomplete="off" class="form-control" aria-label="Recipient's username" aria-describedby="basic-addon2">
            {{City}}</p>
          <span class="input-group-text" id="basic-addon2" (click)="openNav()" style="background: transparent"><i
              class="fa fa-caret-down" aria-hidden="true"></i></span>
        </div>
      </li> -->

    </ul>
    <button *ngIf="!islogIn" class="btn btn-primary rounded-pill px-3 mb-2 mb-lg-0" data-toggle="modal"
      data-target="#exampleModal">
      <span class="d-flex align-items-center">
        <i class="bi bi-file-person me-2"></i>
        <span class="small">Sign-In</span>
      </span>
    </button>
    <div class="btn-group">
      <img *ngIf="islogIn" type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false" [src]="profileImage" class="doctorProfile" />
      <div class="dropdown-menu" *ngIf="islogIn">
        <a class="dropdown-item" routerLink="/auth"><i class="fa fa-user-circle-o" aria-hidden="true"></i>My Account</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" (click)="onLogOut()"><i class="fa fa-sign-out" aria-hidden="true"></i>Log Out</a>
      </div>
    </div>
  </div>
</div>
</nav>
<div class="container w-100">  
</div>
<header class="masthead">
  <div class="container-fluid pl-5 pr-5 ">
    <div class="row  align-items-center">
      <div class="col-lg-6">
        <!-- Mashead text and app badges-->
        <div class="mb-5 mb-lg-0 text-start text-lg-start">
          <h1 class="display-1 lh-1 mb-3"
            style="font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;font-size: 45px">
            <b style="color:#00cec9;">DOCTORS</b> JUST A TOUCH AWAY.
          </h1>
          <p class="lead fw-normal text-muted mb-5">
            Now book appointment with any doctor near you.
          </p>
          <div class="d-flex flex-column flex-lg-row align-items-center">
            <div class="col-md-7" style="padding: 0px;">
            </div>
            <a class="me-lg-3 mb-lg-0" target="_blank" id="butto"
              href="https://play.google.com/store/apps/details?id=com.paspatient"><img class="app-badge"
                style="margin-top: 7px; margin-left: -303px;" src="assets/img/google-play-badge.svg" alt="..." /></a>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="masthead-device-mockup">
          <svg class="circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <linearGradient id="circleGradient" gradientTransform="rotate(65)">
                <stop class="gradient-start-color" offset="0%"></stop>
                <stop class="gradient-end-color" offset="100%"></stop>
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="50"></circle>
          </svg>
          <svg class="shape-1 d-none d-sm-block" viewBox="0 0 240.83 240.83" xmlns="http://www.w3.org/2000/svg">
            <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03"
              transform="translate(120.42 -49.88) rotate(45)"></rect>
            <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03"
              transform="translate(-49.88 120.42) rotate(-45)"></rect>
          </svg><svg class="shape-2 d-none d-sm-block" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="50" r="50"></circle>
          </svg>
          <img src="./assets/img/doktors1.png" style="width:250px;z-index:999; margin-top: 110px;" />
          <!-- <div class="device-wrapper">
                <div
                  class="device"
                  data-device="iPhoneX"
                  data-orientation="portrait"
                  data-color="black"
                >
                  <div class="screen bg-black">
                    <video
                      muted="muted"
                      autoplay=""
                      loop=""
                      style="max-width: 100%; height: 100%"
                    >
                      <source
                        src="assets/img/demo-screen.mp4"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div> -->
        </div>
      </div>
    </div>
  </div>
</header>
<aside class="text-center" style="background-color:#282020;background-repeat: no-repeat;
    background-image:url(assets/img/smartphone.png);
    background-position: left;
  background-size: contain;    background-position-x: 10%;background-size: 473px;
  background-blend-mode: multiply;">
  <!-- <div class="container px-5"> -->
  <div class="row w-100" style="justify-content:right !important;">
    <div class="col-xl-3">
      <img src="./assets/img/doktorslogowhite.png" style="width: 50%;height:auto;
              margin-bottom:20px;" />
    </div>
    <div class="col-xl-8">
      <h3 class=" text-white mb-4" style="color: #c9c1c1 !important;font-family:serif">
        <!-- <img
                src="assets/img/smartphone.png"
                alt="..."
                style="width:10%;position:absolute';right:20"
              /> -->
        <!-- COMMING SOON -->
        "An intuitive solution to a common problem that we all face during
        appointment, wrapped up in a single app!"
      </h3>
      <!-- <img
              src="assets/img/smartphone.png"
              alt="..."
              style="width:10%;position:'absolute';right:10"
            /> -->
      <!-- <button
              type="button"
              style="text-align: right"
              class="btn btn-success bg-gradient-primary-to-secondary"
            >
              BOOK APPOINTMENT
            </button> -->
      <!-- <button type="button" class="btn btn-success">Success</button> -->
    </div>
  </div>
  <!-- </div> -->
</aside>



<!-- ======= Team Section ======= -->
<!-- ======= Hospital LOgo ======= -->

<section id="team" class="team section-bg">
  <div class="container">
    <div class="section-title">
      <h2 *ngIf="CityDoctor && CityDoctor?.total > 0">Top Hospitals</h2>
      <h2 style="color: red;" *ngIf="CityDoctor?.total < 1">Doctor not available on this location</h2>
      <!-- <h3 *ngIf="CityDoctor?.total > 0" style="text-align:center">Top  Hospitals </h3> -->
      <p *ngIf="CityDoctor?.total < 1">Please fill right location</p>
    </div>
    <app-hospitalsicon></app-hospitalsicon>
    <!-- <div class="col-md-12 text-center">
      <button *ngIf="CityDoctor?.total > 1" type="button" class="btn btn-primary text-center my-4"><a href="finddoctor"
          style="color: white;">More Hospital</a></button>
    </div> -->
  </div>
</section>
<section id="features" style="margin-top:-100px;">
  <div class="section-title">
    <h2>Services</h2>
  </div>
  <div class="row gx-5 align-items-center w-100"  style="margin-left: 0;">
    <div class="col-lg-8 order-lg-1 mb-5 mb-lg-0">
      <div class="container-fluid px-5">
        <div class="row gx-5">
          <div class="col-md-6 mb-5">
            <!-- Feature item-->
            <div class="text-center">
              <i class="bi-calendar-date icon-feature text-gradient d-block mb-3"></i>
              <h3 class="font-alt">Make Appointments</h3>
              <p class="text-muted mb-0">
                Make appointments with doctors and get to know there
                availability.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-5">
            <!-- Feature item-->
            <div class="text-center">
              <i class="bi-person-bounding-box icon-feature text-gradient d-block mb-3"></i>
              <h3 class="font-alt">Medical Conditions</h3>
              <p class="text-muted mb-0">
                Save your medical conditions and reports to be reviewed by
                the doctor.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-5 mb-md-0">
            <!-- Feature item-->
            <div class="text-center">
              <i class="bi-file-medical-fill icon-feature text-gradient d-block mb-3"></i>
              <h3 class="font-alt">
                Diagnostic Center Reports on you phone
              </h3>
              <p class="text-muted mb-0">
                Get your Diagnostic center report on your phone
              </p>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Feature item-->
            <div class="text-center">
              <i class="bi-info-square-fill icon-feature text-gradient d-block mb-3"></i>
              <h3 class="font-alt">Get Doctors availability info</h3>
              <p class="text-muted mb-0">
                Get to know the availability of the doctor in any city.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 order-lg-0">
      <!-- Features section device mockup-->
      <div class="features-device-mockup">
        <svg class="circle" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="circleGradient" gradientTransform="rotate(45)">
              <stop class="gradient-start-color" offset="0%"></stop>
              <stop class="gradient-end-color" offset="100%"></stop>
            </linearGradient>
          </defs>
          <circle cx="50" cy="50" r="50"></circle>
        </svg>

        <svg class="shape-1 d-none d-sm-block" viewBox="0 0 240.83 240.83" xmlns="http://www.w3.org/2000/svg">
          <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03"
            transform="translate(120.42 -49.88) rotate(45)"></rect>
          <rect x="-32.54" y="78.39" width="305.92" height="84.05" rx="42.03"
            transform="translate(-49.88 120.42) rotate(-45)"></rect>
        </svg><svg class="shape-2 d-none d-sm-block" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="50" cy="50" r="50"></circle>
        </svg>

        <img src="./assets/img/doktors2.png" style="width:300px;z-index:999;" />

        <!-- <div class="device-wrapper">
                <div
                  class="device"
                  data-device="iPhoneX"
                  data-orientation="portrait"
                  data-color="black"
                >
                  <div class="screen bg-black">
                    <video
                      muted="muted"
                      autoplay=""
                      loop=""
                      style="max-width: 100%; height: 100%"
                    >
                      <source
                        src="assets/img/demo-screen.mp4"
                        type="video/mp4"
                      />
                    </video>
                </div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
  <!-- </div> -->
</section>
<!-- Basic features section-->
<section class="bg-gradient-primary-to-secondary" style="padding-bottom: 200px;">
  <div class="container px-5">
    <div class="row gx-5 align-items-center justify-content-center justify-content-lg-between">
      <div class="col-12 col-lg-5">
        <h2 class="display-4 lh-1 mb-4" style="color:white;font-family:sans-serif">
          GET RID OF LONG QUEUES.
        </h2>
        <p class="lead fw-normal text-muted mb-5 mb-lg-0" style="color:white !important;">
          Now you dont have to wait for long queues for
          <span style="color:#00cec9">DOQMA</span> will automatically notify
          you when the Doctors is ready to see you.
        </p>
      </div>
      <div class="col-sm-8 col-md-6">
        <div class="px-5 px-sm-0">
          <!-- src="https://source.unsplash.com/u8Jn2rzYIps/900x900" -->
          <img class="img-fluid" src="./assets/img/queue.png" alt="..." />
        </div>
      </div>
    </div>
  </div>
</section>
<section class="row w-100" style="margin-top: -200px;">
  <div class="stat-box col" style="background-color:white; ">
      <h2 >Download Count</h2>
      <h3 >15,000</h3>
  </div>
  <div class="stat-box col"  style="background-color:white; ">
      <h2 >Reviews</h2>
      <h3 >4.6/5</h3>
  </div>
  <div class="stat-box col" style="background-color:white; ">
      <h2 >Doctors</h2>
      <h3 >26</h3>
  </div>
  <div class="stat-box col" style="background-color:white;">
      <h2 >Hospitals</h2>
      <h3 >12</h3>
  </div>
</section>
<!-- Call to action section-->
<!-- <section class="cta">
      <div class="cta-content" style="text-align:center">
        <div class="container px-5">
          <h2 class="text-white display-1 lh-1 mb-4">
            Stop waiting.
            <br />
            Start Downloading
          </h2>
          <a class="me-lg-3 mb-4 mb-lg-0" href="#!"
            ><img
              class="app-badge"
              src="assets/img/google-play-badge.svg"
              alt="..."
          /></a>
          <br />
          <img
            class="app-badge"
            style="width:20%;height:20%;margin-top: 50px"
            src="assets/img/whitelogo.png"
            alt="..."
          />
        </div>
      </div>
    </section> -->

<div class="col-md-12"
  style="background-color:#efefef; background-image:url(./assets/img/hexa.png);background-size:contain;background-repeat: no-repeat">
  <!-- <div class="container"> -->
  <div class="row">
    <div class="col-md-6">
      <img class="regimg" src="./assets/img/sketch1660657582055.png" style="width: 75%;
            height: 75%; margin-left: 10px; margin-top: 30px;" />
    </div>
    <div class="col-md-6 section-title" style="padding:30px" id="wrd">
      <h2 style="margin-top: 30px;">
        REGISTER AS DOCTOR
      </h2>
      <div class="container">
        <div class="row">
          <div class="col-4" style="margin-top: 13px;">
            <div class="col-md-4,col-sm-4" style="text-align: center;">
              <img src="./assets/img/clinic.png" style="height:60px;margin-bottom:19px" />
              <p>Personal Clinic</p>
            </div>
          </div>
          <div class="col-4" style="margin-top: 13px;">
            <div class="col-md-4,col-sm-4" style="text-align: center;">
              <img src="./assets/img/hospital.png" style="height:60px;margin-bottom:19px" />
              <p>Hospitals</p>
            </div>
          </div>
          <div class="col-4" style="margin-top: 13px;">

            <div class="col-md-4,col-sm-4" style="text-align: center;">
              <img src="./assets/img/blood-drop.png" style="height:60px;margin-bottom:19px" />
              <p>Diagnostic Centers</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:40px">

      </div>
      <p></p>
      <div class="whatyouget">
        <ul >
          <li style="margin-top: -55px;">
            <i class="bi bi-check-all"></i>PERSONAL APP TO MANAGE
            APPOINTMENTS.
          </li>
          <li>
            <i class="bi bi-check-all"></i>WEB BASED SYSTEM TO MANAGE THE
            SAME.
          </li>
          <li><i class="bi bi-check-all"></i>MARK HOLIDAYS</li>
          <li> <i class="bi bi-check-all"></i>REGISTER ONCE PRACTICE AT MULTIPLE CLINIC/HOSPITALS</li>
        </ul>
      </div>

      <div style="text-align:center">
        <button class="btn btn-dark btn-lg bg-gradient-primary-to-secondary" style="margin:0 auto" routerLink="/auth">
          REGISTER/LOG-IN
        </button>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>

<!-- <app-mrpricing></app-mrpricing> -->


<!-- App badge section-->
<!-- <section class="bg-gradient-primary-to-secondary" id="download">
      <div class="container px-5" style="text-align:center">
        <img class="app-badge" src="assets/img/whitelogo.png" alt="..." />
        <h4 class="text-center text-white font-alt mb-4">Get the app now!</h4>

        <div
          class="d-flex flex-column flex-lg-row align-items-center justify-content-center"
        >
          <a class="me-lg-3 mb-4 mb-lg-0" href="#!"
            ><img
              class="app-badge"
              src="assets/img/google-play-badge.svg"
              alt="..."
          /></a>
          <a href="#!"
            ><img
              class="app-badge"
              src="assets/img/app-store-badge.svg"
              alt="..."
          /></a>
        </div>
      </div>
    </section> -->
<!-- Footer-->
<!-- <footer class="bg-black text-center py-5">
      <div class="container px-5">
        <div class="text-white-50 small">
          <div class="mb-2">
            &copy; www.mavinglobus.com 2021. All Rights Reserved.
          </div>
          <a href="privacypolicy.html" target="_blank">Privacy</a>
          <span class="mx-1">&middot;</span>
          <a href="termscondition.html" target="_blank">Terms</a>
          <span class="mx-1">&middot;</span>
          <a href="refundPolicy.html" target="_blank">Refund</a>
        </div>
      </div>
    </footer> -->
<!-- Feedback modal-->

<div class="modal fade" id="feedbackModal" tabindex="-1" aria-labelledby="feedbackModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-gradient-primary-to-secondary p-4">
        <h5 class="modal-title font-alt text-white" id="feedbackModalLabel">
          Send feedback
        </h5>
        <button class="btn-close btn-close-white" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body border-0 p-4">
        <form>
          <div class="form-floating mb-4">
            <input class="form-control" id="inputName" type="text" placeholder="Enter your name..." />
            <label for="inputName">Name</label>
          </div>
          <div class="form-floating mb-4">
            <input class="form-control" id="inputEmail" type="email" placeholder="name@example.com" />
            <label for="inputEmail">Email address</label>
          </div>
          <div class="form-floating mb-4">
            <input class="form-control" id="inputPhone" type="tel" placeholder="(123) 456-7890" />
            <label for="inputPhone">Phone number</label>
          </div>
          <div class="form-floating mb-4">
            <textarea class="form-control" id="inputMessage" placeholder="Enter your message here..."
              style="height: 10rem"></textarea>
            <label for="inputMessage">Message</label>
          </div>
          <div class="d-grid">
            <button class="btn btn-primary rounded-pill py-3" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<!-- End Footer -->

<a href="#" id="myBtn" class="back-to-top" style="display: none;">
  <i class="bi bi-arrow-up"></i>
</a>
<!-- /// model -->
<div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">PLEASE FIRST SIGN-IN</h5>
        <button type="button" #cls class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
        <div class="col-6">
          <img src="../../assets/2829247.jpg" class="img-fluid" alt="Side Image">
        </div>
        <div class="col-1"></div>
        <div class="col-5">
          <!-- <div class="buttton"> -->
            <!-- routerLink="/patlogin" -->
            <button type="button" class="btn btn-primary btn-lg" (click)="signIn()"
              style="background-color: #00cec9; border:1px solid #00ece9;margin-left: 18%;">Sign-in as patient</button><br><br>
              <!-- <img src="../../assets/WhatsApp Image 2023-08-17 at 6.02.55 PM.jpeg" class="img-fluid" alt="Side Image"> -->
          <!-- </div> -->  
          <!-- <div class="col-4"> -->
            <button type="button" class="btn btn-primary btn-lg" (click)="closeDmodal()"
              style="background-color: #00cec9; border:1px solid #00ece9 ;margin-top: 10%; margin-left: 18%;">Sign-in as Doctor</button><br><br>
          <!-- </div><br/> -->
          <!-- <div class="col-4"> -->
            <!-- <button type="button" class="btn btn-primary btn-lg" (click)="closeMmodal()"
              style="background-color: #00cec9; border:1px solid #00ece9;margin-top: 10%; width:62%;margin-left: 18%;">Sign-in as M.R.</button> -->
          <!-- </div> -->
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
  <div class="input-group w-100 text-center" id="navbarDropdown" role="butt" data-toggle="dropdown"
    style="margin-top: 32px;" aria-haspopup="true" aria-expanded="false">
    <!-- <label for="cityinput"><i class="fa fa-caret-down" aria-hidden="true"></i></label> -->
    <input [value]="City" (input)="findCity($event)" id="cityinput"
      style="text-transform: capitalize;max-width: 200px; border-right: 0; margin-left :25px; " autocomplete="off"
      type="text" class="form-control" placeholder="Enter City" aria-label="Recipient's username"
      aria-describedby="basic-addon2">
    <button type="button" class="btn btn-primary">
      <i class="fa fa-search" aria-hidden="true"></i>
    </button>
  </div>

  <a *ngFor="let city of cities?.predictions" class="dropdown-item1" style=" font-size: 21px; cursor:pointer"
    (click)="onSubmit(city.terms[0].value)">{{city.description}}</a>
  <!-- <div class="dropdown-menu bg-light" aria-labelle dby="navbarDropdown">
    </div> -->
</div>

<!-- Button trigger modal -->
<!-- <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
  Launch demo modal
</button> -->

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>